import { render, staticRenderFns } from "./commonBaseInfo.vue?vue&type=template&id=fd562118&scoped=true"
import script from "./commonBaseInfo.vue?vue&type=script&lang=js"
export * from "./commonBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./commonBaseInfo.vue?vue&type=style&index=0&id=fd562118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd562118",
  null
  
)

export default component.exports